import axios from "axios";
import Config from "../../config/";
import moment from "moment";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;


export function cekAuth() {
  return {
    headers: {
        Authorization: API_KEY + localStorage.getItem("token"),
        'Content-Type':'multipart/form-data'
    }
  };
}

function pushloggingx(requests, description) {
  const url = `${ROOT_URL}logactivity/logactivity/`;
  let ippublic = "-";

  const fdata = new FormData();
  fdata.append("user_id", localStorage.getItem("id"));
  fdata.append("name", localStorage.getItem("name"));
  fdata.append("email", localStorage.getItem("email"));
  fdata.append("issuperuser", localStorage.getItem("is_superuser"));
  fdata.append("ipaddress", localStorage.getItem("ipaddress"));
  fdata.append("location", localStorage.getItem("location"));
  fdata.append("date_created", moment().format("YYYY-MM-DD HH:mm:ss"));
  fdata.append("os", "");
  fdata.append("activity", requests);
  fdata.append("description", description);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function fetchPOIPort() {
  const url = `${ROOT_URL}poi/poi/?search=port`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function deleteLayer(id) {
    const url = `${ROOT_URL}gaspar/gaspar/${id}/`;

    const request = axios.delete(url, cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
    pushloggingx("delete " + url, "Menghapus data layers");
    return request;
}

export function pushLayer(body) {
  const url = `${ROOT_URL}gaspar/gaspar/`;

  const fdata = new FormData();
  fdata.append('url', body.url);
  fdata.append('layer', body.layer);
  fdata.append('legend', body.legend);
  fdata.append('name', body.name);
  //fdata.append('updated_at', moment(body.updated_at,'YYYY-MM-DD'));+
  fdata.append('updated_at', moment().format("YYYY-MM-DD"));
  fdata.append('date_created', moment().format("YYYY-MM-DD"));

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("post " + url, "Menambahkan data layers");
  return request;
}

export function updateLayer(body) {
  const url = `${ROOT_URL}gaspar/gaspar/${body.id}/`;

  const fdata = new FormData();
  fdata.append('url', body.url);
  fdata.append('layer', body.layer);
  fdata.append('legend', body.legend);
  fdata.append('name', body.name);
  fdata.append('updated_at', moment().format("YYYY-MM-DD"));
  fdata.append('date_created', moment().format("YYYY-MM-DD"));
  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("update " + url, "Mengedit data layers");
  return request;
}

export function updateLayerxx(body) {
  const url = `${ROOT_URL}gaspar/gaspar/${body.id}`;

  const fdata = new FormData();
  fdata.append('url', body.url);
  fdata.append('layer', body.layer);
  fdata.append('legend', body.legend);
  fdata.append('name', body.name);
  //fdata.append('updated_at', moment(body.updated_at,'YYYY-MM-DD'));+
  fdata.append('updated_at', moment().format("YYYY-MM-DD"));
  fdata.append('date_created', moment().format("YYYY-MM-DD"));

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function proccessUpload(fileupload, ext) {
  const url = `${ROOT_URL}fileupload/uploadfile/`;

  const fdata = new FormData();
  fdata.append("fileupload", fileupload);
  fdata.append("ext", ext);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}
